import styled from 'styled-components';
import { Quark } from '~/containers/styles';

export const MenuContainer = styled.div`
  ${Quark}
`;
export const MenuList = styled.ul`
  text-align: right;
`;

export const MenuListItem = styled.li`
  float: right;
  font-size: 18px;
  & > a {
    color: #fff;
    &:hover,
    &:focus {
      background-color: #336699 !important;
    }
  }
`;



// WEBPACK FOOTER //
// ./resources/assets/js/components/MenuLink/styles.js